<template>
    <div class="card-input">
        <select
            v-model="base"
            name="collect_address"
            id="collect_address"
            class="card-input__input"
            @change="selectCategory($event)"
            :value="1"
        >
            <option :value="item.id" v-for="(item, i) in JSON.parse(establishments)" :key="i" selected>
                {{ item.name }}
            </option>
        </select>
        <p
            style="
                font-weight: 100;
                font-size: clamp(12px, 0.729545vw, 16px);
                margin-left: 15px;
                margin-bottom: 25px;
                margin-top: 25px;
            "
        >
            <strong style="font-weight: 800">Adresse :</strong> {{ this.address }} {{ this.postal_code }} {{ this.city }}
            {{ this.country }}
        </p>

        <div class="g-row x-around">
            <div>
                <div v-for="(hour, i) in hours">
                    <p style="font-weight: 100; font-size: clamp(12px, 0.729545vw, 16px); text-align: start">
                        <strong style="font-weight: 800">{{ days[i] }} :</strong> {{ hour }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['establishments', 'schedules'],
    name: 'establishmenttest',
    mounted() {
        this.address = JSON.parse(this.establishments)[this.selected - 1].address
        this.postal_code = JSON.parse(this.establishments)[this.selected - 1].postal_code
        this.country = JSON.parse(this.establishments)[this.selected - 1].country
        this.city = JSON.parse(this.establishments)[this.selected - 1].city
        let arr = []
        JSON.parse(this.schedules).forEach((value, index) => {
            if (value.establishment_id == this.selected) {
                arr.push(value.start + ' - ' + value.end + '    ' + value.lunch_start + ' - ' + value.lunch_end)
            }
        })

        this.hours = arr
        // this.days = JSON.parse(this.schedules)[0];
    },
    data: () => ({
        base: 1,
        selected: 1,
        address: '',
        postal_code: '',
        country: '',
        city: '',
        hours: [],
        days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    }),
    methods: {
        selectCategory(event) {
            this.selected = event.target.value
            this.address = JSON.parse(this.establishments)[this.selected - 1].address
            this.postal_code = JSON.parse(this.establishments)[this.selected - 1].postal_code
            this.country = JSON.parse(this.establishments)[this.selected - 1].country
            this.city = JSON.parse(this.establishments)[this.selected - 1].city

            let arr = []
            JSON.parse(this.schedules).forEach((value, index) => {
                if (value.establishment_id == this.selected) {
                    arr.push(value.start + ' - ' + value.end + '    ' + value.lunch_start + ' - ' + value.lunch_end)
                }
            })

            this.hours = arr
        },
    },
}
</script>
